module.exports = __webpack_public_path__ + "img/item_art_crafts_tip.0cfb7dba.png";